import React from "react";
import Container from "./Container";
import Logo from "./icons/Logo";
import { FaFacebookF, FaGithub, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import Button from "./form/button";
import { Link } from "react-router-dom";
import { cn } from "../lib/utils";

export default function Footer() {
    return (
        <footer className="mt-16 flex h-56 w-full items-center border-t border-slate-100 text-slate-600 dark:border-slate-800">
            <Container className="flex flex-col gap-8">
                <div className="flex w-full justify-center">
                    <Logo />
                </div>
                <Socials />
                <div className="flex justify-center">
                    <Link to="/studio" className="text-sm ">
                        <Button variant={"ghost"} size={"ghost"}>
                            Studio
                        </Button>
                    </Link>
                </div>
            </Container>
        </footer>
    );
}

interface SocialProps {
    className?: string;
}
export function Socials({ className }: SocialProps) {
    return (
        <div className={cn("flex items-center justify-center gap-4 font-semibold", className)}>
            <a target="_BLANK" href="https://www.facebook.com/ReinVb/">
                <Button variant="ghost" size="ghost">
                    <FaFacebookF size={20} />
                </Button>
            </a>
            <a target="_BLANK" href="https://www.linkedin.com/in/rein-vanbelleghem-b8b669211/">
                <Button variant="ghost" size="ghost">
                    <FaLinkedinIn size={20} />
                </Button>
            </a>
            <a target="_BLANK" href="https://www.instagram.com/rein.vb/">
                <Button variant="ghost" size="ghost">
                    <FaInstagram strokeWidth={8} size={20} />
                </Button>
            </a>
            <a target="_BLANK" href="https://github.com/ReinVanbelleghem">
                <Button variant="ghost" size="ghost">
                    <FaGithub strokeWidth={8} size={20} />
                </Button>
            </a>
            <a target="_BLANK" href="https://twitter.com/Re1nVb">
                <Button variant="ghost" size="ghost">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 1200 1227" fill="none">
                        <path
                            d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                            fill="currentColor"
                        />
                    </svg>
                </Button>
            </a>
        </div>
    );
}
